module.exports = {
        srcSet: __webpack_public_path__ + "static/media/rent_legal_mobile-640.04e7fdb1.webp"+" 640w",
        images: [{path: __webpack_public_path__ + "static/media/rent_legal_mobile-640.04e7fdb1.webp",width: 640,height: 427}],
        src: __webpack_public_path__ + "static/media/rent_legal_mobile-640.04e7fdb1.webp",
        toString: function(){return __webpack_public_path__ + "static/media/rent_legal_mobile-640.04e7fdb1.webp"},
        
        width: 640,
        height: 427
      }